import { gql } from '@apollo/client';
import config from 'config';

const questionDataIndex = config.algolia.algolia_prefix + 'questions_data';

export const GET_PERSONAS = gql`
    query getQuestionData(
        $field: String!
        $title: String
        $value: String!
        $subject: String!
        $paging: PagingInput!
        $tags: [String]
    ) {
        getQuestionData(
            input: { field: $field, title: $title, value: $value, subject: $subject, paging: $paging, tags: $tags }
        ) {
            data {
                id
                title
                value
                subject
                displayOrder
                tags
                descriptions
            }
        }
    }
`;

export const GET_QUESTIONS_DATA_FROM_ALGOLIA = gql`
    query LocationsQuery(
        $__typename: String!
        $index: String!
        $query: String!
        $filters: String!
        $hit: Number!
        $page: Number!
        $facets: [String]!
    ) {
        getQuestionsDataFromAlgolia
            @algolia(
                __typename: "questionDataAlgolia"
                index: ${questionDataIndex}
                filters: $filters
                hitsPerPage: $hit
                query: $query
                page: $page
                facets: $facets
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
